// extracted by mini-css-extract-plugin
export default {"moreInfo":"moreshowinfo_moreInfo__7iJXo","moreInfoContainer":"moreshowinfo_moreInfoContainer__XNB9X"};